/**
 * Deliberate homonym of `Application/Users/Queries/FetchFacilityUsers.ts`: both target the same
 * route. This one carries only `facilityId`, matching the unfiltered agency directory read it feeds;
 * the other adds `accountId` and `queryParams` for the admin screen's server-side filtering and
 * `usersStore` ownership key.
 */
class FetchFacilityUsers {
	constructor(public readonly facilityId: number) {
		Object.freeze(this);
	}
}

export default FetchFacilityUsers;
